import useMerchandiseCategories from './useMerchandiseCategories'
import useMerchandiseCategoriesList from './useMerchandiseCategoriesList'

type ReturnType = [
  Array<App.MerchandiseCategory>,
  boolean,
  string | undefined,
]

function useMerchandiseTopCategories(): ReturnType {
  const [list, fetchingList, error] = useMerchandiseCategoriesList({
    sortBy: 'top',
    limit: 6,
  })

  const [topCategories, fetchingCategories, categoriesError] = useMerchandiseCategories({
    categoryIds: list,
  })

  return [
    topCategories,
    !!(fetchingList || fetchingCategories),
    error ?? categoriesError,
  ]
}

export default useMerchandiseTopCategories
